import React from 'react'
import { Card, CardContent } from '@/components/ui/card'
import { AlertCircle } from 'lucide-react'
import { BuySubscription } from '@/components/BuySubscription'

export type EmptySubscriptionListStateProps = Record<string, never>
export const EmptySubscriptionListState = ({}: EmptySubscriptionListStateProps) => {
  return (
    <Card className="w-full max-w-md mx-auto border-warning bg-card">
      <CardContent className="flex flex-col items-center justify-center py-8 gap-4">
        <AlertCircle className="h-8 w-8 text-warning mb-2" />
        <p className="text-warning-foreground text-center">
          No active subscriptions found for your account.
        </p>
        <BuySubscription />
      </CardContent>
    </Card>
  )
}
